import { Space } from 'antd'
import { EmailTemplateButton } from './EmailTemplateButton'

const PostEventViewer = function () {
  return <Space size='small' orientation='vertical'>
    <p>Viewer post-event email templates</p>
    <EmailTemplateButton
      type='Post-event - Viewer'
      title='Viewer post event email template'
      settingKey='post-session.viewer.closure' />
  </Space>
}

export default PostEventViewer
